// properties are for debugging purposes only
export const ARRAY    = { ARRAY:    true, toString: () => '[[ARRAY]]' };
export const BOOLEAN  = { BOOLEAN:  true, toString: () => '[[BOOLEAN]]' };
export const FUNCTION = { FUNCTION: true, toString: () => '[[FUNCTION]]' };
export const NUMBER   = { NUMBER:   true, toString: () => '[[NUMBER]]' };
export const OBJECT   = { OBJECT:   true, toString: () => '[[OBJECT]]' };
export const STRING   = { STRING:   true, toString: () => '[[STRING]]' };
export const UNKNOWN  = { UNKNOWN:  true, toString: () => '[[UNKNOWN]]' };
